export interface QuickReply {
  id: string;
  icon: string;
  label: string;
  /** Texto que se inserta en el campo de mensaje. Puede usar {producto}. */
  text: string;
}

/** Mensajes predefinidos para agilizar la conversación con el vendedor. */
export const buyerQuickReplies: QuickReply[] = [
  {
    id: "available",
    icon: "ri-checkbox-circle-line",
    label: "¿Sigue disponible?",
    text: "Hola, ¿este producto sigue disponible?",
  },
  {
    id: "interest",
    icon: "ri-shopping-bag-3-line",
    label: "Me interesa",
    text: "Hola, me interesa «{producto}». ¿Podemos coordinar?",
  },
  {
    id: "shipping",
    icon: "ri-truck-line",
    label: "¿Hacés envíos?",
    text: "¿Hacés envíos? ¿A qué zonas llegás y cuánto cuesta?",
  },
  {
    id: "price",
    icon: "ri-price-tag-3-line",
    label: "Precio final",
    text: "¿Cuál es el precio final? ¿Está incluido el envío?",
  },
  {
    id: "discount",
    icon: "ri-discount-percent-line",
    label: "¿Descuento?",
    text: "¿Hacés algún descuento si compro más de uno?",
  },
  {
    id: "payment",
    icon: "ri-wallet-3-line",
    label: "Formas de pago",
    text: "¿Qué formas de pago aceptás? ¿Efectivo, transferencia o tarjeta?",
  },
  {
    id: "meeting",
    icon: "ri-map-pin-2-line",
    label: "Punto de entrega",
    text: "¿Dónde podríamos encontrarnos para la entrega?",
  },
  {
    id: "warranty",
    icon: "ri-shield-check-line",
    label: "Garantía",
    text: "¿El producto tiene garantía? ¿De cuánto tiempo?",
  },
  {
    id: "thanks",
    icon: "ri-emotion-happy-line",
    label: "Gracias",
    text: "¡Gracias! Quedo atento a tu respuesta.",
  },
];

/** Respuestas rápidas útiles cuando el vendedor atiende a un comprador. */
export const sellerQuickReplies: QuickReply[] = [
  {
    id: "yes-available",
    icon: "ri-checkbox-circle-line",
    label: "Sí, disponible",
    text: "¡Sí, sigue disponible! ¿Te gustaría coordinar la compra?",
  },
  {
    id: "shipping-info",
    icon: "ri-truck-line",
    label: "Sobre envíos",
    text: "Sí, hago envíos. Decime tu zona y te confirmo el costo de entrega.",
  },
  {
    id: "price-firm",
    icon: "ri-price-tag-3-line",
    label: "Precio firme",
    text: "El precio es el publicado. Cualquier duda, con gusto te ayudo.",
  },
  {
    id: "payment-info",
    icon: "ri-wallet-3-line",
    label: "Formas de pago",
    text: "Acepto efectivo y transferencia. Coordinamos según te quede mejor.",
  },
  {
    id: "sold-out",
    icon: "ri-close-circle-line",
    label: "Ya no disponible",
    text: "Lo siento, este producto ya no está disponible. ¿Te interesa algo similar?",
  },
  {
    id: "thank-you",
    icon: "ri-emotion-happy-line",
    label: "Gracias",
    text: "¡Gracias por tu interés! Quedo atento para cualquier consulta.",
  },
];

/** Reemplaza el marcador {producto} por el título real de la publicación. */
export function fillQuickReply(text: string, productTitle?: string): string {
  if (!productTitle) {
    return text.replace(/«\{producto\}»/g, "el producto").replace(/\{producto\}/g, "el producto");
  }
  return text.replace(/\{producto\}/g, productTitle);
}